import apiConfig from "../../api.config";
import { CompanyRegisterModel } from "../../model/company-register.model";
import instanceHR9 from "../instances/hr9.instance";


const getProfile = () => {
  return instanceHR9.get(apiConfig.leela.profile);
};
const getActiveSubscription = () => {
  return instanceHR9.get(apiConfig.leela.active_subscription);
};
const registerProfile = () => {
  return instanceHR9.post(apiConfig.leela.register_profile);
};
const registerCompany = () => {
  return instanceHR9.post(apiConfig.leela.register_company, {
    language: "TH"
});
};
const submitCompanyApproval = (companyModel: FormData) => {
  //multipart/form-data
  return instanceHR9.post(apiConfig.leela.submit_company, companyModel, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
const getCandidateView = (candidate_id) => {
  const formAppend = new URLSearchParams();
  formAppend.append("candidateListIndexNumber", "8");
  formAppend.append("candidateSortType", "8");
  return instanceHR9.get(apiConfig.leela.candidate_view + candidate_id + "?" + formAppend);
}

const getIndustry = () => {
  return instanceHR9.get(apiConfig.leela.company_industry);
}
const getJobRoles = () => {
  return instanceHR9.get(apiConfig.leela.job_role);
}

const getTeamManagement = () => {
  return instanceHR9.get(apiConfig.leela.team_management + "?search=&page=0&pageSize=100&sort=roleName&sortDir=ASC&roleName=");
}

const getDashboard = (company_uuid) => {

  return instanceHR9.get(apiConfig.leela.dashboard + "?search=&sort=postedDateTime&sortDir=DESC&page=0&pageSize=100&jobStatus=ACTIVE");
};

const getDetailJob = (job_id) => {

  return instanceHR9.get(apiConfig.leela.job + job_id)
}


const ScoutConnectService = {
  getProfile,
  getDashboard,
  registerProfile,
  registerCompany,
  getDetailJob,
  getCandidateView,
  getIndustry,
  getJobRoles,
  submitCompanyApproval,
  getTeamManagement
};

export default ScoutConnectService;